export default "__VITE_ASSET__CtLjXA9k__"